import { getReviewsApi } from '../config';

export const {
  getReviewsActions,
  getReviews,
  getReviewsSuccess,
  getReviewsError,
  getReviewsClear,
} = getReviewsApi;
